import Typography from '@mui/material/Typography';
import React from 'react';

import { MissingPermit, MissingRank, PermissionData } from '../../api/types';

interface PermissionsMissingSecondaryProps {
    missingKey: 'missingRanks' | 'missingPermits';
    permissionInfo: PermissionData;
}

export const PermissionsMissingSecondary: React.FC<PermissionsMissingSecondaryProps> = ({
    permissionInfo,
    missingKey,
}) => {
    return (
        <>
            {permissionInfo[missingKey]
                .map((object: MissingPermit | MissingRank) => {
                    if (missingKey === 'missingRanks') {
                        const { rankCode, rankDescription } = object as MissingRank;
                        return { key: rankCode, value: rankDescription };
                    } else {
                        const { permitID, permitDescription } = object as MissingPermit;
                        return { key: permitID, value: permitDescription };
                    }
                })
                .map(({ key, value }) => (
                    <Typography variant="body2" key={key} style={{ paddingLeft: '0.8rem' }}>
                        {missingKey === 'missingRanks' && <>{key} -</>} {value}
                    </Typography>
                ))}
        </>
    );
};
